import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.map.js";
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
const userVuex = createNamespacedHelpers("user");
export default {
  name: "my-token",
  inject: ["reload"],
  computed: {
    ...walletVuex.mapState(["isMobile", "netId", "isWallet"]),
    ...userVuex.mapState(["token", "etherUSD"])
  },
  watch: {
    isWallet: {
      handler(newBool, oldBool) {
        if (!newBool) return;
        this.walletWeb3Init();
      },
      deep: true
      // immediate: true,
    },
    selectTab: {
      async handler(newTab, oldTab) {
        if (newTab !== oldTab && this.isWallet) {
          if (newTab === "tokensihold") {
            this.isMyTokenLoading = true;
            this.myTokenPage.page = 1;
            await this.setMyToken();
            this.isMyTokenLoading = false;
          } else if (newTab === "launchedbyme") {
            this.isMyLaunchedLoading = true;
            this.myLaunchedPage.page = 1;
            await this.setMyLaunchedToken();
            this.isMyLaunchedLoading = false;
          }
        }
      }
    }
  },
  data() {
    const tab = [{
      label: this.$lang("Tokens I hold"),
      value: "tokensihold"
    }, {
      label: this.$lang("Launched by me"),
      value: "launchedbyme"
    }];
    return {
      tab,
      selectTab: null,
      isAdd: false,
      myToken: null,
      myTokenPage: {
        total: 100,
        page: 1,
        perPage: 30
      },
      isMyTokenLoading: true,
      isMyLaunchedLoading: true,
      myLaunched: null,
      myLaunchedPage: {
        total: 100,
        page: 1,
        perPage: 30
      }
    };
  },
  methods: {
    ...walletVuex.mapActions(["doConnect"]),
    ...userVuex.mapActions(["getMyToken", "getMyLaunchToken"]),
    onSkip() {
      this.$router.push("/");
    },
    async walletWeb3Init() {
      await this.noWalletWeb3Init();
    },
    async noWalletWeb3Init() {
      if (this.selectTab === "tokensihold") {
        await this.setMyToken();
      } else {
        await this.setMyLaunchedToken();
      }
    },
    async setMyToken() {
      let page = this.myTokenPage.page;
      let perPage = this.myTokenPage.perPage;
      const res = await this.getMyToken({
        wallet: this.web3Wallet.address,
        perPage,
        page
      });
      if (!res) {
        this.isMyTokenLoading = false;
        return;
      }
      this.isMyTokenLoading = false;
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: item.pool_price ? _v.fmt_pre(_v.bigNumber(_v.fmt_sc(item.pool_price)).times(item.total_supply).times(this.etherUSD), 0) : 0,
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          // sold_token: item.pool_price ? _v.fmt_pre(_v.bigNumber(_v.fmt_sc(item.pool_ether)).div(_v.maxEther).times(100), 3) : 0, //当前卖出代币占比
          sold_token: item.pool_price !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });
      this.myTokenPage.total = res.total;
      this.myToken = list;
    },
    async setMyLaunchedToken() {
      let page = this.myLaunchedPage.page;
      let perPage = this.myLaunchedPage.perPage;
      const res = await this.getMyLaunchToken({
        wallet: this.web3Wallet.address,
        perPage,
        page
      });
      if (!res) {
        this.isMyLaunchedLoading = false;
        return;
      }
      const list = res.items.map(item => {
        return {
          ...item,
          marketCap: _v.fmt_pre(_v.bigNumber(item.pool_price).times(item.total_supply).times(this.etherUSD), 0),
          //市值
          tradingVolume: _v.fmt_pre(_v.fmt_sc(item.volume)),
          //交易量
          priceGain24h: _v.fmt_pre(item.diff * 100, 2),
          //24小时价格上涨百分比
          sold_token: item.pool_price !== null ? this.bigNumber(item.pool_ether).div(this.maxEther).times(100).toFixed(18) : 0 //当前卖出代币占比
        };
      });
      this.isMyLaunchedLoading = false;
      this.myLaunchedPage.total = res.total;
      this.myLaunched = list;
    },
    onAdd() {
      this.$router.push("/launch");
    },
    onMyTokenPage(page) {
      this.myTokenPage.page = page;
      this.setMyToken();
    },
    onMyLaunchedPage(page) {
      this.myLaunchedPage.page = page;
      this.setMyLaunchedToken();
    }
  }
};